"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _constants = require("../../../../../../constants");
var _Tooltip = _interopRequireWildcard(require("../../../../../ui/Tooltip"));
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Services = function Services(_ref) {
  var compact = _ref.compact,
    services = _ref.services,
    className = _ref.className;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames2.default)(_styles.default.resultHotelServices, _defineProperty({}, _styles.default.compact, compact), className)
  }, R.map(function (_ref2) {
    var label = _ref2.label,
      service = _ref2.service;
    return _constants.FAVORIT_SERVICES_ICONS[service] && /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
      content: label,
      key: service,
      placement: _Tooltip.PLACEMENTS.TOP,
      trigger: [_Tooltip.TRIGGERS.HOVER]
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _styles.default.resultHotelService,
      dangerouslySetInnerHTML: {
        __html: _constants.FAVORIT_SERVICES_ICONS[service]
      },
      key: _constants.FAVORIT_SERVICES_ICONS[service].toString()
    }));
  }, services));
};
Services.propTypes = {
  services: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string.isRequired,
    service: _propTypes.default.string.isRequired
  })).isRequired,
  compact: _propTypes.default.bool,
  className: _propTypes.default.string
};
var _default = exports.default = (0, _react.memo)(Services);